import React from "react";
import { withTranslation } from "react-i18next";
import {
  faDownload,
  faCircleNotch,
  faFileAlt,
  faSearch,
  faLaptop,
  faPause,
  faPlay,
  faShieldAlt,
  faBolt,
  faClock,
  faHandPaper
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DateTimeHelper from "../../../../../helpers/DateTimeHelper";
import {faExclamationTriangle, faWifi, faBatteryThreeQuarters, faBatteryHalf, faBatteryQuarter, faBatteryFull} from "@fortawesome/fontawesome-free-solid";
import DeviceStatus from "../../../../../helpers/DeviceStatus";

const ExaminationInstanceIndicatorCell = props => {

  const createBadge = (id, color, value, symbol) => {
    return (
        <FontAwesomeIcon className={color} title={value} icon={symbol} />
    );
  }

  const createBadgeStacked = (id, color1, value, symbol1, symbol2, color2) => {
    return (
        <span className="fa-layers fa-fw" key={id + "-s"}>
          <FontAwesomeIcon className={color1} title={value} icon={symbol1} />
          <FontAwesomeIcon className={color2} title={value} icon={symbol2} size="xs" />
      </span>
    );
  }

  const displayIndicators = () => {
    return props.examination && (
        (props.examination.status >= 0 && props.examination.status <= 2)
        || (props.examination.status >= 50 && props.examination.status <= 53)
        || (props.examination.status >= 10 && props.examination.status <= 13)
        || (props.examination.status >= 31 && props.examination.status <= 32)
    );
  }

  const getRemoteAttestationStatus = () => {
    let remoteAttestation = "";

    if (props.instance.memberDevice && typeof props.instance.memberDevice["status"] !== "undefined") {
      switch (props.instance.memberDevice.status) {
        case 0:
          remoteAttestation = displayIndicators() ? <FontAwesomeIcon
              title={props.t(DeviceStatus.getTranslationByStatus(props.instance.memberDevice.status))}
              icon={faSearch}
              className="color-yellow" />: "";
          break;
        case 10:
          remoteAttestation = displayIndicators() ? <FontAwesomeIcon
              title={props.t(DeviceStatus.getTranslationByStatus(props.instance.memberDevice.status))}
              icon={faLaptop}
              className="color-black" />: "";
          break;
        case 20:
          remoteAttestation = displayIndicators() ? <FontAwesomeIcon
              title={props.t(DeviceStatus.getTranslationByStatus(props.instance.memberDevice.status))}
              icon={faLaptop}
              className="color-green" />: "";
          break;
        case 30:
          remoteAttestation = displayIndicators() ? <FontAwesomeIcon
              title={props.t(DeviceStatus.getTranslationByStatus(props.instance.memberDevice.status))}
              icon={faShieldAlt}
              className="color-green" /> : "";
          break;
        case 40:
          remoteAttestation = <b><FontAwesomeIcon
              title={props.t(DeviceStatus.getTranslationByStatus(props.instance.memberDevice.status))}
              icon={faExclamationTriangle}
              className="color-red ml-1" /></b>;
          if (typeof props.instance.memberDevice["error"] !== "undefined" &&  props.instance.memberDevice.error !== null) {
            if (typeof props.instance.memberDevice.error["message"] !== "undefined") {
              if (props.instance.memberDevice.error.message.indexOf("Lost heartbeat") !== -1) {
                remoteAttestation = <b><FontAwesomeIcon
                    title={props.instance.memberDevice.error.message}
                    icon={faClock}
                    className="color-yellow" /></b>;
              }else{
                remoteAttestation = <b><FontAwesomeIcon
                    title={props.instance.memberDevice.error.message}
                    icon={faExclamationTriangle}
                    className="color-red" /></b>;
              }
            }
          }
          break;
        case 11:
        case 12:
        case 21:
        case 50:
          remoteAttestation = displayIndicators() ? <FontAwesomeIcon
              title={props.t(DeviceStatus.getTranslationByStatus(props.instance.memberDevice.status))}
              icon={faCircleNotch}
              className="color-black" spin />: "";
          break;
        default:
          remoteAttestation = displayIndicators() ? <FontAwesomeIcon
              title={props.t(DeviceStatus.getTranslationByStatus(props.instance.memberDevice.status))}
              icon={faExclamationTriangle}
              className="color-yellow" />: "";
          break;
      }
    }
    return remoteAttestation;
  }
  const raisedHand = () => (
      props.instance.memberDeviceHealth && displayIndicators() && props.instance.memberDeviceHealth.raisedHand
          ? (<FontAwesomeIcon icon={faHandPaper} className="color-yellow mr-2" />) : "")

  const getMemberDeviceHealth = () => {

    let memberDeviceHealth = "-";
    if (props.instance.memberDeviceHealth){
      let status = props.instance._id === props.instance.memberDeviceHealth.instanceId ? (
          <FontAwesomeIcon icon={faPlay} className="color-green" />
      ) : (
          <FontAwesomeIcon icon={faPause} className="color-black" />
      );

      let linkQuality = createBadge(
          `${props.instance._id}-wifi`,
          "color-green",
          `${props.instance.memberDeviceHealth.linkQuality}%`,
          faWifi
      );


      if (props.instance.memberDeviceHealth.linkQuality <= 65.0 && props.instance.memberDeviceHealth.linkQuality > 40.0){
        linkQuality = createBadge(
            `${props.instance._id}-wifi`,
            "color-yellow",
            `${props.instance.memberDeviceHealth.linkQuality}%`,
            faWifi
        );
      }else if(props.instance.memberDeviceHealth.linkQuality <= 40.0){
        if (props.instance.memberDeviceHealth.linkQuality < 1.0){
          linkQuality = <s>
            <FontAwesomeIcon className="color-red" title={`${props.instance.memberDeviceHealth.linkQuality}%`} icon={faWifi} />
          </s>
        }else{
          linkQuality = createBadge(
              `${props.instance._id}-wifi`,
              "color-red",
              `${props.instance.memberDeviceHealth.linkQuality}%`,
              faWifi
          );
        }
      }

      const prec = props.instance.memberDeviceHealth.batteries.reduce((accu, cur) => accu + cur, 0.0) /
          props.instance.memberDeviceHealth.batteries.length;

      let batteryBadge = [
        `${props.instance._id}-battery`,
        "color-green",
        `${prec}%`,
        faBatteryThreeQuarters
      ];
      if (prec >= 95){
        batteryBadge = [
          `${props.instance._id}-battery`,
          "color-green",
          `${prec}%`,
          faBatteryFull
        ];
      }else if(prec <= 50 && prec > 25){
        batteryBadge = [
          `${props.instance._id}-battery`,
          "color-yellow",
          `${prec}%`,
          faBatteryHalf
        ];
      }else if (prec <= 25){
        batteryBadge = [
          `${props.instance._id}-battery`,
          "color-red",
          `${prec}%`,
          faBatteryQuarter
        ];
      }
      const battery = props.instance.memberDeviceHealth.acConnected ?
          createBadgeStacked(batteryBadge[0], batteryBadge[1], batteryBadge[2], batteryBadge[3], faBolt, "color-black") :
          createBadge(batteryBadge[0], batteryBadge[1], batteryBadge[2], batteryBadge[3]);

      memberDeviceHealth = displayIndicators() ? <div style={{fontSize: "11pt"}}>
        {linkQuality} {battery} {status}
      </div> : "-";
    }
    return memberDeviceHealth;
  }

  const paperNotes = () => ((props.onHasNotes(props.instance) ? (<FontAwesomeIcon icon={faFileAlt} className="color-black ml-1" />) : ""))
  return (
      <div>
        <div>
          {raisedHand()}
          {getRemoteAttestationStatus()}
          {paperNotes()}
        </div>
        {getMemberDeviceHealth()}
      </div>
  );
}

export default withTranslation()(ExaminationInstanceIndicatorCell);
